export const BRAND_NAME = 'The Recovery Directory';
export const DIRECTORY_NAME = 'The Recovery Directory';
export const BRANDED_DIRECTORY_NAME = `${DIRECTORY_NAME} by ${BRAND_NAME}`;
export const NEWSLETTER_NAME = 'The Recovery Digest';
export const BRAND_HEADLINE = 'Find the best saunas & cold plunges in London';
export const BRAND_HEADLINE_PREFIX = 'Find the best saunas & cold plunges in';
export const BRAND_HEADLINE_LOCATIONS = ['London', 'Richmond', 'Hackney', 'Chelsea', 'Hampstead'];
export const BRAND_SUBHEAD = 'Saunas, cold plunges, and contrast therapy. Curated and trusted across England.';
export const PRIMARY_CITY_SLUG = 'london';
export const PRIMARY_CITY_NAME = 'London';
export const SITE_ORIGIN = 'https://www.therecoverydirectory.co.uk';
